// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__L4WH1","logo":"Logo_logo__4doca","logoText":"Logo_logoText__UiEQ-"};